import { render } from "./OrderDetails.vue?vue&type=template&id=22008a17&ts=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=22008a17&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__